// extracted by mini-css-extract-plugin
module.exports = {"showMore":"index-module--showMore--3TT3g","active":"index-module--active--1VUS7","shown":"index-module--shown--2d0Es"};